import { ROLES } from '@moal/api'
import moment from 'moment'
import { NEW_USER_THRESHOLD_DAYS } from '../../../constants/general'
import Badge from '../../../graphics/Badge'
import CustomBadges from '../CustomBadges'

export default function UserBadges({ role, user, registrationDate }) {
  const start = moment(registrationDate)
  const end = moment(registrationDate).add(NEW_USER_THRESHOLD_DAYS, 'days')
  const between = moment().isBetween(start, end)

  return (
    <>
      {between && <Badge badge="new" />}
      {role === ROLES.ADMIN && <Badge badge={ROLES.ADMIN} />}
      {role === ROLES.MODERATOR && <Badge badge={ROLES.MODERATOR} />}
      {role === ROLES.HOST && <Badge badge={ROLES.HOST} />}
      {role === ROLES.EXPERT && <Badge badge={ROLES.EXPERT} />}
      {role === ROLES.VIP && <Badge badge={ROLES.VIP} />}
      {role === ROLES.BOT && <Badge badge={ROLES.BOT} />}
      {role === ROLES.SUBSCRIBER && <CustomBadges user={user} />}
    </>
  )
}
